import { BaseAPI, RequiredError, JSONApiResponse } from "../runtime.js";
import { VariationGet200ResponseFromJSON } from "../models/VariationGet200Response.js";
import { VariationWithoutIdentifierGet200ResponseFromJSON } from "../models/VariationWithoutIdentifierGet200Response.js";
import { VariationsByKeysGet200ResponseInnerFromJSON } from "../models/VariationsByKeysGet200ResponseInner.js";
class DefaultApi extends BaseAPI {
  /**
   * 一人のユーザの1つのkeyの情報をbooleanで取得。もっとも頻繁に呼ばれる想定。 keyが存在しないときはfalseを返す。  identifierはちょうど1つだけ指定できる。Darklaunch v1であったような、User.idとOrganization.idの組み合わせ、などといった指定方法はできない。 
   */
  async variationGetRaw(requestParameters, initOverrides) {
    if (requestParameters["key"] == null) {
      throw new RequiredError(
        "key",
        'Required parameter "key" was null or undefined when calling variationGet().'
      );
    }
    if (requestParameters["identifierNamespace"] == null) {
      throw new RequiredError(
        "identifierNamespace",
        'Required parameter "identifierNamespace" was null or undefined when calling variationGet().'
      );
    }
    if (requestParameters["identifier"] == null) {
      throw new RequiredError(
        "identifier",
        'Required parameter "identifier" was null or undefined when calling variationGet().'
      );
    }
    const queryParameters = {};
    if (requestParameters["key"] != null) {
      queryParameters["key"] = requestParameters["key"];
    }
    if (requestParameters["identifierNamespace"] != null) {
      queryParameters["identifier_namespace"] = requestParameters["identifierNamespace"];
    }
    if (requestParameters["identifier"] != null) {
      queryParameters["identifier"] = requestParameters["identifier"];
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/variation`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => VariationGet200ResponseFromJSON(jsonValue));
  }
  /**
   * 一人のユーザの1つのkeyの情報をbooleanで取得。もっとも頻繁に呼ばれる想定。 keyが存在しないときはfalseを返す。  identifierはちょうど1つだけ指定できる。Darklaunch v1であったような、User.idとOrganization.idの組み合わせ、などといった指定方法はできない。 
   */
  async variationGet(requestParameters, initOverrides) {
    const response = await this.variationGetRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * ユーザにかかわらず、1つのkeyの情報をbooleanで取得。全ユーザを同一視してよい特殊なケースで使う。 keyが存在しないときはfalseを返す。 
   */
  async variationWithoutIdentifierGetRaw(requestParameters, initOverrides) {
    if (requestParameters["key"] == null) {
      throw new RequiredError(
        "key",
        'Required parameter "key" was null or undefined when calling variationWithoutIdentifierGet().'
      );
    }
    const queryParameters = {};
    if (requestParameters["key"] != null) {
      queryParameters["key"] = requestParameters["key"];
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/variation-without-identifier`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => VariationWithoutIdentifierGet200ResponseFromJSON(jsonValue));
  }
  /**
   * ユーザにかかわらず、1つのkeyの情報をbooleanで取得。全ユーザを同一視してよい特殊なケースで使う。 keyが存在しないときはfalseを返す。 
   */
  async variationWithoutIdentifierGet(requestParameters, initOverrides) {
    const response = await this.variationWithoutIdentifierGetRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   * 一人のユーザの複数のkeyの情報をまとめてbooleanで取得。 keyが存在しないときはfalseを返す。 
   */
  async variationsByKeysGetRaw(requestParameters, initOverrides) {
    if (requestParameters["keys"] == null) {
      throw new RequiredError(
        "keys",
        'Required parameter "keys" was null or undefined when calling variationsByKeysGet().'
      );
    }
    if (requestParameters["identifierNamespace"] == null) {
      throw new RequiredError(
        "identifierNamespace",
        'Required parameter "identifierNamespace" was null or undefined when calling variationsByKeysGet().'
      );
    }
    if (requestParameters["identifier"] == null) {
      throw new RequiredError(
        "identifier",
        'Required parameter "identifier" was null or undefined when calling variationsByKeysGet().'
      );
    }
    const queryParameters = {};
    if (requestParameters["keys"] != null) {
      queryParameters["keys[]"] = requestParameters["keys"];
    }
    if (requestParameters["identifierNamespace"] != null) {
      queryParameters["identifier_namespace"] = requestParameters["identifierNamespace"];
    }
    if (requestParameters["identifier"] != null) {
      queryParameters["identifier"] = requestParameters["identifier"];
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/variations-by-keys`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => jsonValue.map(VariationsByKeysGet200ResponseInnerFromJSON));
  }
  /**
   * 一人のユーザの複数のkeyの情報をまとめてbooleanで取得。 keyが存在しないときはfalseを返す。 
   */
  async variationsByKeysGet(requestParameters, initOverrides) {
    const response = await this.variationsByKeysGetRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
const VariationGetIdentifierNamespaceEnum = {
  UserId: "User.id",
  OrganizationId: "Organization.id",
  AyaPgAccountId: "Aya::Pg::Account.id",
  PercentageSeed: "PercentageSeed"
};
const VariationsByKeysGetIdentifierNamespaceEnum = {
  UserId: "User.id",
  OrganizationId: "Organization.id",
  AyaPgAccountId: "Aya::Pg::Account.id",
  PercentageSeed: "PercentageSeed"
};
export {
  DefaultApi,
  VariationGetIdentifierNamespaceEnum,
  VariationsByKeysGetIdentifierNamespaceEnum
};
